import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
const TALLY_URL = 'https://tally.so/r/Ek57zL';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/gTDxox6zehr7hdBHYwo7U1/Main_Big_png.png';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white ${isScrolled ? 'shadow-md py-3' : 'py-4'}`} initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} data-id="element-103">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8" data-id="element-104">
        <div className="flex items-center gap-2" data-id="element-105">
          <img src={LOGO_URL} alt="VeriProp" className="h-10 w-auto" data-id="element-106" />
        </div>

        <a href={TALLY_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center rounded-lg bg-[#E8531E] text-white hover:bg-[#CC4A15] font-semibold h-9 px-4 text-sm transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#E8531E] shadow-lg shadow-orange-900/20" data-id="element-107">
          Join Waitlist
        </a>
      </div>
    </motion.nav>;
}